module.exports = __webpack_public_path__ + "seven.03da689439f6b0c096b5.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/seven/seven.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/seven/seven.jpg
// module chunks = 0